import * as React from "react";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

{
  /* <Typography sx={{ color: "#4CC417" }}>
File upload complete
</Typography> */
}

function LinearProgressWithLabel(
  props: LinearProgressProps & {
    value: number;
    stage: string;
    crop: string;
    size: number;
  }
) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {props.stage === "FETCHED_FILE_INFORMATION" ? (
        <Typography sx={{ color: "#4CC417" }}>File upload complete</Typography>
      ) : (
        <React.Fragment>
          <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress
              variant={
                props.stage === "UPLOADING_FILE"
                  ? "determinate"
                  : "indeterminate"
              }
              {...props}
            />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            {props.crop === "crop" ? (
              <Typography variant="body2" color="text.secondary">
                Cropping...
              </Typography>
            ) : (
              <Typography variant="body2" color="text.secondary">{`${
                props.value ? props.value.toFixed(0) + "%" : " "
              }`}</Typography>
            )}
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}

const ProgressBar = ({
  value,
  size,
  stage,
  crop,
}: {
  value: number;
  size: number;
  stage: string;
  crop: string;
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <LinearProgressWithLabel
          value={value}
          stage={stage}
          crop={crop}
          size={size}
        />
      </Box>
    </Box>
  );
};
export default ProgressBar;
